import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ErrorHandlerService } from '../error-handler-service/error-handler.service';
import { StorageService } from '../storege-service/storage.service';
import { Router } from '@angular/router';
import { ToolService } from '../tool/tool.service';

const BASE_URL = environment.BASE_URL;
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class HttpService {
  constructor(
    private router: Router,
    private httpClient: HttpClient,
    private error: ErrorHandlerService,
    private storageSrv: StorageService,
    private toolService: ToolService,
  ) {
  }

  async post(fun, param, loading, isFormData = false) {
    return new Promise<any>(async (resolve, reject) => {
      if (!environment.production) { this.toolService.showConsoleLog('[ %cHTTP POST', 'font-weight: bold', '] Call to', fun); }
      // if (loading) { await this.sharedSrv.loadingPresent(); }
      const headerData = (fun !== 'login') ? await this.generateHeader() : {};
      const bodyData = isFormData ? await this.appendObj(param) : param;
      this.httpClient.post(BASE_URL + fun + '/', bodyData, headerData)
        .subscribe(async res => {
          const data: any = res;
          this.toolService.showConsoleLog(data);
          // if (loading) { await this.sharedSrv.loadingDismiss(); }
          if (!environment.production) { this.toolService.showConsoleLog('HttpClient response:', res); }
          // await this.responseHeaderHandler(res.headers);
          this.responseBodyHandler(data)
            .then(data => {
              resolve(data);
            })
            .catch(err => {
              reject(err);
            });
        },
          async err => {
            // if (loading) { await this.sharedSrv.loadingDismiss(); }
            if (!environment.production) {
              //this.toolService.showConsoleLog('HttpClient Error: ' , err);
              //this.toolService.showConsoleLog('HttpClient Error: ' , err.error);
            }
            //this.storageSrv.signOut();
            //this.router.navigate(['/login/']);
            reject(err);
          });
    });
  }


  generateHeader() {
    return new Promise<any>(async (resolve) => {
      const token = this.storageSrv.getToken();
      const facilityId = this.storageSrv.getFacilityId();
      const httpOptions = {
        headers: new HttpHeaders({
          'x-token': token,
          'facilityId': facilityId,
          'x-secret': this.getSecret(),
        })
      };
      resolve(httpOptions);
    });
  }

  getCurrentDateTime=()=> {
    const now = new Date();
  
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0'); // +1 because getMonth() returns 0-11
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    const seconds = String(now.getSeconds()).padStart(2, '0');
  
    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  }
  


  // generateHeadersForJava() {
  //   const token = this.storageSrv.getToken();

  //   return new HttpHeaders({
  //     'x-secret': this.getSecret(),
  //     'x-token': token,
  //     'x-datetime':this.getCurrentDateTime(),
  //     "x-country":"BH"
  //   })
  //   Object.assign(headers, extras);

  //   return new HttpHeaders(headers);
  // }

  generateHeadersForJava(extras?:object) {
    const secret = this.getSecret();
    const token = this.storageSrv.getToken();

    let headers = {};
    headers['x-secret'] = secret;
    headers['x-token'] = token;
    headers['x-datetime']=this.getCurrentDateTime();
    headers['x-country'] = "BH";

    Object.assign(headers, extras);
    return new HttpHeaders(headers);
  }

  responseBodyHandler(res) {
    return new Promise<any>(async (resolve, reject) => {
      if (res.result && res.result.isSuccess) {
        // if (res.result.showAlert) { this.sharedSrv.alert(res.result.title, null, res.result.desc); }
        if (!environment.production) { this.toolService.showConsoleLog('responseBodyHandler: ', res.data); }
        resolve(res.data);
      } else {
        // if (res.result.showAlert) { this.sharedSrv.alert(res.result.title, null, res.result.desc); }
        if (!environment.production) { this.toolService.showConsoleLog('responseBodyHandlerError: ', res.result); }
        reject(res.result);
      }
    });
  }

  getSecret() {
    const validPattern = ['1,4,5', '2,2,6', '5,3,2', '6,2,2', '7,3,0', '8,1,1'];
    const randomElement = validPattern[Math.floor(Math.random() * validPattern.length)];
    const pattern = randomElement.split(',');
    let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890";
    const val = this.makeRandom(13, possible) + pattern[0] + this.makeRandom(16, possible) + pattern[1] + this.makeRandom(21, possible) + pattern[2] + this.makeRandom(11, possible);
    return val;
  }

  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  responseHeaderHandler(headers) {
    return new Promise<any>(async (resolve) => {
      if (!environment.production) { this.toolService.showConsoleLog('responseHeaderHandler: ', headers); }
      if (headers.get('token')) {
        await this.setToken(headers.get('token'));
        resolve(true);
      }
      else {
        resolve(true);
      }
    });
  }

  setToken = (token) => {
    return new Promise<any>((resolve) => {
      this.storageSrv.setToken(token);
      resolve(token);
    });
  }

  appendObj = (obj) => {
    return new Promise<FormData>((resolve) => {
      const formData = new FormData();
      Object.keys(obj).forEach(async key => {
        if (!Array.isArray(obj[key])) {
          // if (key == 'file') {
          //   this.toolService.showConsoleLog(key);
          //   this.toolService.showConsoleLog(obj[key]);
          //   formData.append(key, obj[key], obj[key].name);
          // }
          // else {
          formData.append(key, obj[key]);
          // }
        }
        else {
          formData.append(key, JSON.stringify(obj[key]));
        }
      });
      resolve(formData);
    });
  }
}
